import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

//Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button, Pill } from '@gpstrackit/gtc-react-controls';

//Actions
import { etaContactsReset } from './redux/slice';
import { catalogLoad } from 'Redux/actions';
const EtaContacts = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    //Redux States
    const contacts = useSelector(state => state.catalogsRedux.contacts);
    const loadingContacts = useSelector(state => state.catalogsRedux.loadingContacts);
    const open = useSelector((state) => state.etaContactsRedux.open);
    const data = useSelector((state) => state.etaContactsRedux.data);

    //Local States
    const [list, setList] = useState([]);

    const handleClose = () => {
        dispatch(etaContactsReset());
        setList([]);
    }

    useEffect(() => {
        if (open) {
            dispatch(catalogLoad(['contacts']));
        }
    }, [open])

    useEffect(() => {
        if (open && !loadingContacts && data?.sharedWith) {
            let currentContacts = []
            let sharedWith = data?.sharedWith
            if (sharedWith?.contacts?.length) {
                sharedWith?.contacts.map((item) => {
                    let currentContact = contacts.find((contact) => contact?.id === item)
                    if (currentContact?.id) {
                        currentContacts.push({
                            id: currentContact?.id,
                            value: currentContact?.address,
                            type: "CONTACT",
                            contactType: currentContact?.type
                        })
                    }
                })
            }
            if (sharedWith?.emails?.length) {
                sharedWith?.emails.map((item) => {
                    currentContacts.push({
                        id: item,
                        value: item,
                        type: "EMAIL",
                        contactType: ""
                    })
                })
            }
            if (sharedWith?.sms?.length) {
                sharedWith?.sms.map((item) => {
                    currentContacts.push({
                        id: item,
                        value: item,
                        type: "SMS",
                        contactType: ""
                    })
                })
            }
            setList(currentContacts)
        }
    }, [open, loadingContacts])

    useEffect(() => {
        return () => {
            handleClose()
        }
    }, [])

    return (
        <Modal
            title={messages['eta_contacts']}
            open={open}
            position="right"
            size="small"
            className="modal-top-0"
            headerStyle={{ top: 0 }}
            handleClose={handleClose}
            loading={loadingContacts}
        >
            <ModalBody>
                <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>
                    {
                        list?.length ? list.map((item, index) => {
                            return (
                                <Pill
                                    key={index}
                                    size="full"
                                    textField="name"
                                    item={{ label: `${item?.value}`, color: '#66bb6a' }}
                                    disabled={false}
                                    style={{ marginBottom: 5 }}
                                />
                            )
                        })
                    : <div style={{ display: 'flex', justifyContent: 'center', opacity: 0.4 }}>{messages['no_data']}</div>}
                </div>
            </ModalBody>
            <ModalFooter style={{ bottom: 50 }}>
                <Button
                    onClick={handleClose}
                    className="btn-blue"
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default EtaContacts;